import React from "react";

/**
 * Лендинг админ-панели (`#/admin`). Показывает ссылки на разделы.
 */
export function AdminLandingPage(): JSX.Element {
    return (
        <div className="page admin-landing">
            <div className="page-header">
                <h2>Admin panel</h2>
            </div>
            <div className="admin-cards">
                <a className="admin-card" href="#/admin/merchants">
                    <span className="admin-card-icon">M</span>
                    <strong>Merchants</strong>
                    <span>Список, фильтр, создание, правка, архивирование и API-токены.</span>
                </a>
                <a className="admin-card" href="#/admin/merchant-withdrawals">
                    <span className="admin-card-icon">W</span>
                    <strong>Merchant withdrawals</strong>
                    <span>Ручная отправка и фиксация tx-hash для вывода USDT.</span>
                </a>
                <a className="admin-card" href="#/admin/ip-allowlist">
                    <span className="admin-card-icon">I</span>
                    <strong>IP Allowlist</strong>
                    <span>Белый список IP для merchant API и глобальный тумблер фильтра.</span>
                </a>
                <a className="admin-card" href="#/admin/traders">
                    <span className="admin-card-icon">T</span>
                    <strong>Traders</strong>
                    <span>Списки трейдеров и команд, создание команд и трейдеров.</span>
                </a>
                <a className="admin-card" href="#/admin/disputes">
                    <span className="admin-card-icon">D</span>
                    <strong>Disputes</strong>
                    <span>Список заявок в appeal и ручное разрешение споров.</span>
                </a>
                <a className="admin-card" href="#/admin/telegram">
                    <span className="admin-card-icon">TG</span>
                    <strong>Telegram</strong>
                    <span>Получатели уведомлений о новых заявках: добавление, включение и проверка доставки.</span>
                </a>
                <a className="admin-card" href="#/admin/history">
                    <span className="admin-card-icon">H</span>
                    <strong>History</strong>
                    <span>История заявок с попытками, scope=all и фильтрами по трейдеру или команде.</span>
                </a>
                <a className="admin-card" href="#/admin/activity">
                    <span className="admin-card-icon">A</span>
                    <strong>Activity</strong>
                    <span>Платёжные действия по заявкам: завершение, отмена и спор без претензии на полный audit journal.</span>
                </a>
            </div>
        </div>
    );
}
